import React, { useState, useEffect } from 'react';
import moment from 'moment';

import { SingleRedio, SingleText } from '../../Res/BaseInput';
import { UploadButtonSM } from '../../Res/BaseButton';
import { photo_auth_arr, get_photo_auth_string } from '../../../../item/MyStat/ItemMyStatBase';
import { api_upload_file } from '../../../../api/apiUpload';
import { RespResumeOtherAttachment } from '../../../../item/ItemResume';
import Swal from 'sweetalert2';
import { loginPageInfo } from '../../../../config';


export function UploadPhoto({ title = "", photoWidth = 400, photoHeight = 225, defaultPhoto = "/img/profile_big.jpg", Photo, PhotoAuth, PhotoDate, setIsLoading, set_Photo, set_PhotoAuth, set_PhotoDate, isEdit }) {

    const [photo, set_photo] = useState("")
    const [photo_auth, set_photo_auth] = useState(0)
    const [photo_date, set_photo_date] = useState("")
    const [file, setFile] = useState()

    useEffect(() => {
        if (Photo !== undefined && Photo !== photo) {
            set_photo(Photo)
        }
    }, [Photo])

    useEffect(() => {
        if (PhotoAuth !== undefined && PhotoAuth !== photo_auth) {
            set_photo_auth(PhotoAuth)
        }
    }, [PhotoDate])

    useEffect(() => {
        if (PhotoDate !== undefined && PhotoDate !== photo_date) {
            set_photo_date(PhotoDate)
        }
    }, [PhotoDate])

    useEffect(() => {
        // console.log(set_PhotoAuth)
        set_PhotoAuth(photo_auth)
    }, [photo_auth])

    function upload_photo() {
        if (file === undefined) {
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: "您沒有選擇檔案",
            })
            return
        }
        setIsLoading(true)
        api_upload_file({
            file,
            success: (jsonData) => {
                // console.log(jsonData)
                var mRespResumeOtherAttachment = new RespResumeOtherAttachment({})
                mRespResumeOtherAttachment.fromJson(jsonData.info)
                set_Photo(mRespResumeOtherAttachment.filePath)
                set_PhotoDate(mRespResumeOtherAttachment.creatAt)
                set_photo(mRespResumeOtherAttachment.filePath)
                set_photo_date(mRespResumeOtherAttachment.creatAt)
                delete_photo()
                // mRespResumeOtherAttachment.note = note
                // setAll(mRespResumeOtherAttachment)
                // setAttachment(index, mRespResumeOtherAttachment)
                setIsLoading(false)
            },
            failure: (err) => {
                setIsLoading(false)
                Swal.fire({
                    type: 'error',
                    title: '提醒',
                    text: err.message,
                })
            }
        })
    }

    function delete_photo() {
        if (file !== undefined) {
            // setFilePath("")
            // setFileName("")
            // setFileType("")
            // setCreatAt("")
            setFile(undefined)
        } else {
            set_Photo("")
        }
    }



    return <div className="ibox float-e-margins">
        <div className="ibox-content no-padding profile-content">
            <h4>{title}</h4>
        </div>
        <div>
            <div className="ibox-content no-padding border-left-right">
                <div className="row">
                    <div className="col-md-10 col-md-offset-1">
                    <img alt={title} className="img-responsive"
                        style={{width:photoWidth, height:photoHeight, boxAlign:"center"}}
                        src={(photo === "" || photo === undefined) ? defaultPhoto : loginPageInfo.getServerUrl() + photo}
                    />
                    </div>
                </div>
            </div>
            <div className="ibox-content profile-content">
                <div className="row">
                    <div className="col-md-8">
                        <p>照片比例為 9:16
              {
                                photo === "" ?
                                    <></>
                                    : <> ; 上傳日期 {moment(photo_date).format('YYYY-MM-DD')}</>
                            }
                        </p>
                    </div>
                    {
                        isEdit ?
                            <SingleRedio
                                arr={photo_auth_arr}
                                val={photo_auth ? 1 : 0}
                                action={set_photo_auth}
                                size={4}
                            />
                            :
                            <SingleText
                                val={get_photo_auth_string(photo_auth)}
                                size={4} color={'default'} />
                    }
                </div>
                <p>&nbsp;</p>
                {
                    isEdit ?
                        <div className="user-button">
                            <div className="row">
                                {file === undefined ?
                                    <div className="col-md-6">
                                        <input className="btn" type="file" name="file" accept="" onChange={e => setFile(e.target.files[0])} />
                                    </div>
                                    : <UploadButtonSM action={upload_photo} id={photo} name={"上傳"} size={6} />
                                }
                                <UploadButtonSM action={delete_photo} id={photo} name={"刪除"} size={6} color={"btn-default"} icon={"fa-trash"} />
                            </div>
                        </div>
                        : <></>}
            </div>
        </div>
    </div>
}